<template>
  <div class="container">
    <div>
      <p class="icon-jujue closeBtn" @click="routerBack"></p>
    </div>
    <div class="searchBox_top">
      <div>
        <el-button v-if="fpaLtoSignOff" type="primary" @click="attachmentUpload">{{$t('fpaManage.permanent.signatureUpload')}}</el-button>
        <el-button v-if="fpaLtoSubmit" type="primary" @click="fpaLtoApprove('toNfcApprove')">{{$t('common.submit')}}</el-button>
        <!-- Download Attachment是指:在nfc/mdm/供应商角色下,除了供应商反馈状态 其他状态都可以查看 -->
        <el-button v-if="canDownload" type="primary" @click="attachmentDownload">{{$t('fpaManage.permanent.attachmentDownload')}}</el-button>
        <el-button v-if="canApprove" type="primary" @click="fpaLtoApprove('approving')">Approve</el-button>
        <el-button v-if="canApprove" type="primary" @click="fpaLtoApprove('reject')">Reject</el-button>
        <!-- Download by PDF  改成NFC/MDM/供应商都可以查看，不区分状态 -->
        <el-button v-if="isMdm" type="primary" @click="fpaPdfDownload">{{$t('fpaManage.permanent.pdfDownload')}}</el-button>
        <!-- <el-button type="primary" @click="routerBack">{{$t('common.close')}}</el-button> -->
      </div>
    </div>
    <el-form :model="formData" ref="formData" label-width="230px" label-position="left">
      <div class="view_content">
        <div class="fpaNo">
          <p>FPA NO:</p>
          <p>{{formData.serialNo}}</p>
        </div>
        <div class="status">
          <p>Status:</p>
          <p>{{formData.status}}</p>
        </div>
        <div class="creator">
          <p>Creator:</p>
          <p>{{formData.createUser}}</p>
        </div>
        <div class="createDate">
          <p>Creation Date:</p>
          <p>{{formData.createDate}}</p>
        </div>
      </div>
      <!-- Basic Information -->
      <div class="info_box">
        <div class="info_box_title">
          <p class="line"></p>
          <p class="info_title">Basic Information</p>
        </div>
        <!-- Purpose of the Agreemen -->
        <el-row :gutter="20">
          <el-col :span="13">
            <el-form-item prop="purposeOfTheAgreement" style="width:100%">
              <p slot="label">
                <span class="icon-fenlei element_icon"></span>
                Purpose of the Agreement
              </p>
              <el-select v-model="formData.agreementPurpose" disabled style="width:100%">
                <el-option :key="index" v-for="(item,index) in agreementPurposeList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- Supplier -->
        <el-row :gutter="20">
          <el-col :span="13">
            <el-form-item prop="supplierName" style="width: 100%">
              <p slot="label">
                <span class="el-icon-user-solid element_icon"></span>
                Supplier Group
              </p>
              <el-input disabled v-model="formData.supplierName" style="width: 100%" :title="formData.supplierName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- Campaign Start Date Campaign End Date -->
        <el-row :gutter="20">
          <el-col :span="7">
            <el-form-item prop="agreementStartDate" style="width: 100%;">
              <p slot="label">
                <span class="el-icon-date element_icon"></span>
                Campaign Start Date
              </p>
              <el-date-picker type="date" placeholder="选择日期" v-model="formData.agreementStartDate" value-format="yyyy-MM-dd" style="width: 100%;" disabled></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Campaign End Date" label-width="140px" prop="agreementEndDate" style="width: 100%;">
              <el-date-picker type="date" placeholder="选择日期" v-model="formData.agreementEndDate" value-format="yyyy-MM-dd" style="width: 100%;" disabled></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- Product or Commodity -->
        <el-row :gutter="20">
          <el-col :span="13">
            <el-form-item prop="productOrCommodityPurchased" style="width:100%">
              <p slot="label" class="required_p">
                <span class="icon-miaoshu element_icon"></span>
                Product or Commodity Purchased
              </p>
              <el-input disabled v-model="formData.productOrCommodityPurchased"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <div class="tab_box">
      <el-tabs v-model="activeName">
        <el-tab-pane label="PQCP" name="fpaPqcpTab">
          <el-table :data="formData.fpaLtoPqcnList" max-height="500" ref="fpaLtoPqcnList1" border>
            <el-table-column show-overflow-tooltip align="center" prop="supplierName" label="Supplier" width="300px">
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" prop="plantName" label="Facility" width="300px">
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" prop="dcIdList" label="Supplied DC" width="300px">
              <template slot-scope="scope" v-if="scope.row.isLocal=='1'">
                <ic-select disabled table="BASE" field="DC" v-model="scope.row.dcIdList" :multiple="true" :clearable="true"></ic-select>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" prop="newMenuItemName" label="Menu Item" width="150px">
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" prop="ingredient" label="Ingredient" width="120px">
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" prop="localItem" label="Local Item#" width="100px">
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Price per CASE(RMB EXCL. VAT)" width="250px">
              <el-table-column align="center" prop="purchaseForcast" label="Price" width="150px">
                <template slot-scope="scope">
                  <el-input :value="scope.row.purchaseForcast  | thousandSeparator" disabled></el-input>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="uom" label="Unit" width="150px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.uom" disabled>
                    <el-option :key="index" v-for="(item,index) in uomList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                  </el-select>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" prop="vat" label="VAT" width="90px">
              <template slot-scope="scope">
                <el-select v-model="scope.row.vat" disabled>
                  <el-option :key="index" v-for="(item,index) in pqcnVatRateList" :value="item.code" :label="item | inputChoiceI18n"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Price Valid Date" width="150px">
              <el-table-column align="center" prop="priceValidDateFrom" label="From" width="150px">
                <template slot-scope="scope">
                  <el-date-picker type="date" placeholder="选择日期" v-model="scope.row.priceValidDateFrom" value-format="yyyy-MM-dd" style="width: 100%;" disabled></el-date-picker>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="priceValidDateTo" label="to" width="150px">
                <template slot-scope="scope">
                  <el-date-picker type="date" placeholder="选择日期" v-model="scope.row.priceValidDateTo" value-format="yyyy-MM-dd" style="width: 100%;" disabled></el-date-picker>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" prop="tradeTerm" label="Trade Term" width="250px">
              <template slot-scope="scope">
                <el-select v-model="scope.row.tradeTerm" disabled>
                  <el-option :key="index" v-for="(item,index) in priceTypeList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" prop="packagingSize" label="Packing Size per CASE" width="250px">
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" prop="externalPackagingNetweight" label="Net Weight (KG)" width="250px">
            </el-table-column>
            <!--<el-table-column align="center" prop="totalEstimatedQty" label="Total Estimated Qty(Case)" width="200px">
                        </el-table-column>
                        <el-table-column align="center" prop="totalEstimatedAmount" label="Total Estimated Amount (RMB)" width="250px">
                        </el-table-column>-->
            <el-table-column show-overflow-tooltip align="center" prop="transportaionMethod" label="Delivery Type" width="150px">
              <template slot-scope="scope">
                <el-select v-model="scope.row.transportaionMethod" disabled>
                  <el-option :key="index" v-for="(item,index) in newTransportaionMethodList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" prop="freight" label="Freight" width="150px">
              <template slot-scope="scope">{{scope.row.freight  | thousandSeparator}}</template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" prop="totalCost" label="Total Cost(without VAT)" width="250px">
              <template slot-scope="scope">{{scope.row.totalCost |fix(2) | thousandSeparator}}</template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Promotion Date From" width="200">
              <template slot-scope="scope">
                <el-date-picker disabled v-model="scope.row.promotionDateFrom" type="date" value-format="yyyy-MM-dd"></el-date-picker>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Promotion Date To" width="200">
              <template slot-scope="scope">
                <el-date-picker disabled v-model="scope.row.promotionDateTo" type="date" value-format="yyyy-MM-dd"></el-date-picker>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane v-if="formData.ttFpaLtoId > 0" label="Audit Record" name="fpaLog">
          <el-table :data="formData.auditLogList" border highlight-current-row class="table">
            <el-table-column show-overflow-tooltip sortable prop="operatorName" align="center" label="Update by"></el-table-column>
            <el-table-column show-overflow-tooltip sortable prop="createDate" align="center" label="Update Time">
              <template slot-scope="scope">
                {{scope.row.createDate|dateFormatFilter("YYYY-MM-DD HH:mm:ss")}}
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip sortable prop="action" align="center" label="Update Log"></el-table-column>
            <el-table-column show-overflow-tooltip sortable prop="comments" align="center" label="Suggestion"></el-table-column>
            <el-table-column show-overflow-tooltip sortable align="center" label="Attachment">
              <template slot-scope="scope">{{scope.row.effectiveBeginDate | dateFormatFilter("YYYY-MM-DD HH:mm")}}
                <fileList :files="scope.row.docs"></fileList>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!--附件-->
    <el-dialog :visible.sync="showFileUpload" append-to-body width="80%">
      <FileUpload ref="fileUploadRef" :multiple="false" :max-length="fileListMaxLength" :recType="bizType" :bizId="formData.ttFpaLtoId" :attachmentAccept="attachmentAccept" :seq="0" :showFileList="false" :disabled="fileUploadDisabled"></FileUpload>
    </el-dialog>
    <!--审批页面-->
    <el-dialog :visible.sync="showAuditPage" append-to-body width="25%" :title="dialogTitle" class="fpa">
      <el-form :model="formData" ref="formData">
        <!-- <el-row type="flex" justify="center"> -->
        <!-- <el-col :span="20"> -->
        <!-- <p style="height:40px;line-height:40px">{{$t('fpaManage.permanent.auditRemark')}}</p> -->
        <!-- </el-col> -->
        <!-- </el-row> -->
        <el-row type="flex" justify="center">
          <el-col :span="20" :offset="2">
            <el-form-item prop="auditRemark" :label="$t('fpaManage.permanent.auditRemark')" style="width:100%" :class="dialogTitle=='Reject'?'is-required':''">
              <el-input type="textarea" :rows="3" style="width:100%" v-model="formData.auditRemark" class="handle-input" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center">
          <el-button type="primary" @click="fpaLtoApprove('confirm')">Confirm</el-button>
          <el-button type="primary" @click="showAuditPage=false">Cancel</el-button>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import commonFunction from "@/utils/dataTableUtils";
import fpaLtoApi from "@/api/fpa/fpaLto";
import { inputChoiceService } from "@/api/common/input-choice";
import utils from "@/utils/commonFun";
import FileUpload from "@/components/common/fileUpload";
import fileList from "@/components/common/fileList"
import { fileService } from "@/api/common/file-utils";
import commonFun from "@/utils/commonFun";

export default {
  components: { IcSelect, FileUpload, fileList },
  name: "fpaLtoDetail",
  data() {
    return {
      isMdm: false,
      ttFpaLtoId: null,
      ttFpaLtoPqcnId: null,
      showSelSupplierDialog: false,
      supplierIds: [],
      activeName: "fpaPqcpTab",
      formData: {
        operateType: '',
        tmSupplierId: null,
        ttFpaLtoId: null,
        ttFpaLtoCampaignId: null,
        fpaNo: '',
        fpaName: '',
        createDate: null,
        createUser: '',
        status: '',
        queryStatus: '',
        agreementPurpose: '',
        purchaseFrequency: '',
        agreementStartDate: null,
        agreementEndDate: null,
        productOrCommodityPurchased: '',
        auditResult: 'Y',
        auditRemark: '',
      },
      fpaSave: true,
      fpaLtoSubmit: true,
      fpaLtoSignOff: true,
      canApprove: false,
      canDownload: false,
      statusList: [],
      agreementPurposeList: [],
      fpaSupplierCoverageList: [],
      fpaSupplierCoverageSelect: [],
      fpaPcnSelect: [],
      fpaPqcnSelect: [],
      newTransportaionMethodList: [],
      priceTypeList: [],
      uomList: [],
      pqcnVatRateList: [],
      showFileUpload: false,
      fileUploadDisabled: false,
      attachmentAccept: '.pdf',
      localItemFileUploadDisabled: false,
      showAuditPage: false,
      auditPerson: localStorage.getItem("ms_username"),
      auditDate: new Date(),
      bizType: 'FPA_LTO',
      fileListMaxLength: 1,
      localItemBizType: 'FPA_LTO_ITEM',
    };
  },
  created() {
    console.log(this.$route.params);
    let ttFpaLtoId = this.$route.params.ttFpaLtoId;
    this.ttFpaLtoId = ttFpaLtoId;
    this.formData.ttFpaLtoId = ttFpaLtoId;
    this.getInputChoiceValues();
    this.fpaLtoDetail(ttFpaLtoId);
    const roles = localStorage.getItem("ms_roles");
    // 角色必须是：mdm nfc 潜在供应商
    if ((roles.indexOf("MDM_TEAM") != -1 || roles.indexOf("NFC_ADMIN") != -1 || roles.indexOf("POTENTIAL_SUPPLIER") != -1)) {
      this.isMdm = true;
    }
  },
  methods: {
    //下拉列表数据获取
    getInputChoiceValues() {
      let mapObj = {};
      mapObj["TT_FPA_LTO:STATUS"] = "TT_FPA_LTO:STATUS";
      mapObj["TT_FPA_LTO_CAMPAIGN:PURPOSE_AGREEMENT"] = "TT_FPA_LTO_CAMPAIGN:PURPOSE_AGREEMENT";
      mapObj["TM_MATERIAL_RECORD:PRICE_TYPE"] = "TM_MATERIAL_RECORD:PRICE_TYPE";
      mapObj["TM_MATERIAL_RECORD:MINIMUM_ORDER_UNIT"] = "TM_MATERIAL_RECORD:MINIMUM_ORDER_UNIT";
      mapObj["TM_MATERIAL_RECORD:URCHASE_TAX_RATE"] = "TM_MATERIAL_RECORD:URCHASE_TAX_RATE";
      mapObj["TM_MATERIAL:DIS_TYPE"] = "TM_MATERIAL:DIS_TYPE";
      inputChoiceService.getInputChoiceValues(mapObj).then((res) => {
        this.statusList = res["TT_FPA_LTO:STATUS"];
        this.agreementPurposeList = res["TT_FPA_LTO_CAMPAIGN:PURPOSE_AGREEMENT"];
        this.priceTypeList = res["TM_MATERIAL_RECORD:PRICE_TYPE"];
        this.uomList = res["TM_MATERIAL_RECORD:MINIMUM_ORDER_UNIT"];
        this.pqcnVatRateList = res["TM_MATERIAL_RECORD:URCHASE_TAX_RATE"];
        this.newTransportaionMethodList = res["TM_MATERIAL:DIS_TYPE"];
      });
    },
    fpaLtoDetail() {
      this.canApprove = false;
      this.fpaSave = false;
      this.fpaLtoSubmit = false;
      this.canDownload = false;
      this.fpaLtoSignOff = false

      fpaLtoApi.fpaLtoDetail(this.formData.ttFpaLtoId).then((res) => {
        let ms_Permission = JSON.parse(localStorage.getItem("ms_Permission"));
        console.log('ms_Permission', ms_Permission);
        res.data.fpaLtoPqcnList.forEach(pqcn => {
          if (commonFun.isNotEmpty(pqcn.dcs)) {
            pqcn.dcIdList = pqcn.dcs.split(",");
          }
        })
        this.formData = res.data;
        let supplierObj = localStorage.getItem("supplierObj");
        let ms_userId = localStorage.getItem("ms_userId");
        let isSupplier = false;
        let isAuditor = false;
        if (supplierObj && JSON.parse(supplierObj).supperSupplierId == this.formData.tmSupplierId) {
          isSupplier = true;
        }
        if (this.formData.auditorId == ms_userId) {
          isAuditor = true;
        }
        //待供应商反馈或已退回
        if (this.formData.queryStatus == 'nfcApproving'
          && (this.formData.status == 'suFeedback' || this.formData.status == 'reject')
          && isSupplier && ms_Permission.indexOf('FpaLtoSubmit') != -1) {
          this.fpaLtoSubmit = true;
        }
        if (this.formData.queryStatus == 'nfcApproving'
          && (this.formData.status == 'suFeedback' || this.formData.status == 'reject')
          && isSupplier && ms_Permission.indexOf('FpaLtoUploadSignoffDocument') != -1) {
          this.fpaLtoSignOff = true;
        }
        const roles = localStorage.getItem("ms_roles");
        //待NFC审批或已提交
        if ((roles.indexOf("MDM_TEAM") != -1 || roles.indexOf("NFC_ADMIN") != -1 || roles.indexOf("POTENTIAL_SUPPLIER") != -1) && (this.formData.status !== 'suFeedback')) {
          this.canDownload = true;
        }

        //待NFC审批
        if (this.formData.status == 'nfcApproving' && isAuditor) {
          this.canApprove = true;
        }
        //MDM检查
        if (this.formData.status == 'mdmCheck' && this.formData.canAudit) {
          this.canApprove = true;
        }
        this.$forceUpdate();
      });
    },
    fpaLtoApprove(operateType) {
      if ("approving" == operateType) {
        this.dialogTitle = 'Approve'
        this.formData.auditResult = 'Y'
        this.showAuditPage = true;
      } else if ("reject" == operateType) {
        this.dialogTitle = 'Reject'
        this.formData.auditResult = 'N'
        this.showAuditPage = true;
      } else if ("toNfcApprove" == operateType) {
        if (this.checkPqcn()) {
          //您确定要提交吗？
          this.$confirm('Would you like to submit this document!', 'Tips', {
            confirmButtonText: this.$t('common.confirm'),
            cancelButtonText: this.$t('common.cancel'),
            cancelButtonClass: 'btn_custom_cancel',
            customClass: 'colorBtn',
            type: 'warning'
          }).then(() => {
            fpaLtoApi.fpaLtoSubmit(this.formData).then((res) => {
              if (res.data) {
                this.routerBack();
              } else {
                this.$message.error(res.msg || this.$t("common.operateError"));
              }
            });
          })
        };
        //NFC审批
      } else if ("confirm" == operateType) {
        if (this.formData.auditResult == 'N' && utils.isEmpty(this.formData.auditRemark)) {
          //退回时备注不能为空
          this.$message.error(this.$t('fpaManage.permanent.pleaseInputAuditRemark'))
          return false;
        }
        this.formData.operateType = operateType;
        //您确定要提交吗？
        this.$confirm('Would you like to submit this document!', 'Tips', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          cancelButtonClass: 'btn_custom_cancel',
          customClass: 'colorBtn',
          type: 'warning'
        }).then(() => {
          fpaLtoApi.fpaLtoApprove(this.formData).then((res) => {
            this.showAuditPage = false;
            if (res.data) {
              this.routerBack();
            } else {
              this.$message.error(res.msg || this.$t("common.operateError"));
            }
          });
        });
      }
    },
    attachmentUpload() {
      this.showFileUpload = true;
      this.fileUploadDisabled = false;
    },
    attachmentDownload() {
      this.showFileUpload = true;
      this.fileUploadDisabled = true;
    },
    checkPqcn() {
      let nullMsg = '';
      let errorMsg = '';
      this.formData.fpaLtoPqcnList.forEach(pqcn => {
        if (!pqcn.priceValidDateFrom || !pqcn.priceValidDateTo) {
          nullMsg += pqcn.localItem + ',';
          return false;
        }
        if (new Date(pqcn.priceValidDateTo).getTime() < new Date(pqcn.priceValidDateFrom).getTime()) {
          errorMsg += pqcn.localItem + ',';
          return false;
        }
      });
      if (nullMsg) {
        //没有维护Price Valid Date
        this.$message.error(nullMsg.slice(0, nullMsg.length - 1) + this.$t('fpaManage.lto.PriceValidDateCheck1'))
        return false;
      }
      if (errorMsg) {
        //Price Valid Date开始时间晚于结束时间
        this.$message.error(errorMsg.slice(0, errorMsg.length - 1) + this.$t('fpaManage.lto.PriceValidDateCheck2'))
        return false;
      }
      return true;
    },
    fpaPdfDownload() {
      fpaLtoApi.fpaLtoPdfDownload(this.formData).then(res => {
        fileService.respToFile(res, 'FpaLto.pdf');
      });
    },
    routerBack() {
      this.$router.back();
      //this.$root.eventHub.$emit("onSelectItem", '/sorManage');
    },
  },
  extends: commonFunction
};
</script>
<style lang="scss" scoped>
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  display: inline-block;
}

// 整体内容
.fpaDetail {
  width: calc(100% - 20px);
  padding: 10px;
  background-color: #fff;
}
// 第一行只可view
.view_content {
  height: 50px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.35);
  border-radius: 6px;
  margin-top: 10px;
  display: flex;
  align-content: center;
  justify-content: space-between;
  .fpaNo,
  .status,
  .creator,
  .createDate {
    width: 20%;
    height: 40px;
    padding: 5px 0;
    text-align: center;
    border-right: 1px solid #ddd;
    p {
      height: 20px;
      line-height: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .approver {
    width: 20%;
    height: 40px;
    padding: 5px 0;
    text-align: center;
  }
}
// 第二行整体
.info_box {
  margin-top: 10px;
  border-radius: 6px;
  padding: 0 10px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.35);
}
// 模块的标题
.info_box_title {
  height: 30px;
  display: flex;
  flex-direction: row;
  justify-content: start;
}
.info_title {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
  margin-left: 5px;
}
.line {
  width: 3px;
  height: 16px;
  margin: 7px 0;
  background-color: #f8ab01;
}
.tab_box {
  background-color: #fff;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.35);
  padding: 10px;
  margin-top: 10px;
  border-radius: 6px;
}
.el-icon-date:before,
.el-icon-menu:before,
.el-icon-notebook-2:before,
.el-icon-user-solid:before,
.el-icon-s-marketing:before {
  font-size: 22px;
  vertical-align: middle;
  color: #7f7f7f;
}
</style>
